import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowUpward = () => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M12.0466 6.38016L7.99998 2.3335L3.95331 6.38016M7.99998 13.6668V2.44683",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});